<template>
  <div class="u-ml4">
    <el-popover
      placement="bottom"
      trigger="click"
      popper-class="companies-list__popover">
      <el-checkbox-group v-model="checked" class="companies-list__checkbox_vertical">
        <el-checkbox v-for="company in availableCompanies"
                     :key="company.id"
                     :label="company.id"
                     @change="updateCompaniesList"
        >
          {{ company.name }}
        </el-checkbox>
      </el-checkbox-group>
      <el-button slot="reference">Manage Companies List</el-button>
    </el-popover>
  </div>
</template>

<script>
  export default {
    name: 'ba-company-select',
    watch: {
      availableCompanies: {
        handler (value) {
          this.$emit('onChangeCompaniesList', this.selectedCompanies)
        },
        immediate: true
      }
    },
    props: {
      availableCompanies: {
        type: Array,
        default: []
      }
    },
    mounted () {
      this.showAllCompanies()
    },
    data () {
      return {
        checked: []
      }
    },
    computed: {
      selectedCompanies () {
        let res = []
        if (!this.availableCompanies) return null
        this.availableCompanies.forEach(comp => {
          this.checked.forEach(id => {
            if (comp.id === id) res.push(comp)
          })
        })
        return res
      }
    },
    methods: {
      showAllCompanies () {
        if (!this.availableCompanies) return []
        let companiesList
        let savedData = localStorage.getItem('visibleCompanies')
        if (savedData !== null) {
          companiesList = JSON.parse(savedData)
        } else {
          companiesList = this.availableCompanies.map(el => el.id)
        }
        this.setCompaniesList(companiesList)
        this.updateCompaniesList()
      },
      setCompaniesList (data) {
        this.checked = data
      },
      updateDataToLocalStorage () {
        localStorage.setItem('visibleCompanies', JSON.stringify(this.checked))
      },
      updateCompaniesList () {
        this.updateDataToLocalStorage()
        this.$emit('onChangeCompaniesList', this.selectedCompanies)
      }
    }
  }
</script>

<style lang="scss">
  .el-dropdown .el-button-group {
    display: flex;
    height: 100%;
  }
  
  .companies-list {
    &__popover {
      max-height: 400px;
      overflow-y: scroll;
    }
    &__checkbox_vertical {
      display: flex;
      flex-direction: column;
      .el-checkbox {
        line-height: 30px;
        &__label {
          font-size: 16px;
        }
      }
    }
  }
</style>
